<template>
  <div class="gc-shared-opentowork__wrapper">
    <div class="avatar">
      <img
        v-if="opentoworkStatus"
        :src="openToWork_profileIcon_white"
        class="gc-shared-opentowork__icon-dashboard"
      />
      <img :src="src" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Avatar",
  props: {
    src: String,
  },
  computed: {
    opentoworkStatus() {
      return Grabcad.opentoworkStore.state.opentoworkStatus;
    },
  },
  data() {
    return {
      openToWork_profileIcon_white: window.Grabcad.openToWork_profileIcon_white,
    };
  },
};
</script>

<style lang="scss" scoped>
.avatar {
  margin: 0 auto;
  margin-top: -50px;
  border: 5px solid #ffffff;
  box-sizing: border-box;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  overflow: hidden;

  width: 100px;
  height: 100px;

  > img {
    width: 90px;
    height: 90px;
  }
}
</style>